import { Stack,Accordion } from "react-bootstrap"
import {ReactComponent as BackIcon} from '../assets/back.svg'
import { useNavigate } from "react-router-dom"

function MemeJourneyFAQ() {
    const navigate  = useNavigate();
    return (
        <div class="chat-background d-flex justify-content-center">
            <div className="chat-container">
                <Stack className=" mx-2 mx-md-5 px-md-5 py-5 vh-100" gap={4}>
                    <Stack style={{cursor:'pointer',opacity:'0.7'}} direction="horizontal" gap={2} onClick={()=>navigate('/')}>
                        <BackIcon className="icon"/><span>Back to Login</span>
                    </Stack>
                    <h4 className="text-center">Frequently Asked Questions</h4>
                    <Accordion >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>How to get access to Memejourney?</Accordion.Header>
                            <Accordion.Body>
                            Here are the steps:
                            <ul>
                                    <li>1. Join the discord community</li>
                                    <li>2. Go to meme-generator channel</li>
                                    <li>Use command /generate "meme theme or description" or command /create "meme text" "meme type"</li>
                                    <li>Use any of the 4 generated memes or try a different description</li>
                            </ul>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>How to unlock premium features?</Accordion.Header>
                            <Accordion.Body>
                                Invite 5 friends via to link below
                                <br/> 
                                <a target="_blank" href="https://upvir.al/143676/lp143676">https://upvir.al/143676/lp143676</a>

                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="4">
                            <Accordion.Header>What features are available on Memejourney?</Accordion.Header>
                            <Accordion.Body>
                            <ul>
                                    <li>Generate memes based on theme</li>
                                    <li>AI Memes based generated powered by ChatGPT</li>
                                    <li>Free access without any limits</li>
                            </ul>

                            </Accordion.Body>
                        </Accordion.Item>			
                    </Accordion>
                    
                </Stack>
            </div>
        </div>
    )
}

export default MemeJourneyFAQ